import * as React from "react";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import handleMutationError from "app/utils/handleMutationError";
import { withRouter } from "react-router-dom";

type Props = {
  applicationStatusMessage: any;
  onClose: Function;
  deactivateApplicationStatusMessage: any;
  history: any;
};

type State = {
  updating: boolean;
};

class ApplicationStatusMessageDeactivationConfirmationModal extends React.Component<
  Props,
  State
> {
  state = { updating: false };

  submit = () => {
    this.setState({ updating: true });
    this.props
      .deactivateApplicationStatusMessage({
        variables: {
          id: this.props.applicationStatusMessage.id.toString(),
        },
      })
      .then(() => {
        this.setState({ updating: false });
        this.props.onClose();
        window.location.reload(false);
      })
      .catch((error) => {
        handleMutationError(error);
      });
  };

  render() {
    return (
      <Dialog
        open={this.props.applicationStatusMessage != null}
        onClose={() => this.props.onClose()}
      >
        <DialogTitle>
          <DialogContentText>
            Confirm deactivation of status message:
          </DialogContentText>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            The following status message{" "}
            <strong>
              {this.props.applicationStatusMessage.status_message.message_body}
            </strong>
            , with a level of{" "}
            <strong>
              {this.props.applicationStatusMessage.status_message.level}
            </strong>
            , will be removed from the{" "}
            <strong>
              {this.props.applicationStatusMessage.application.application_name}
            </strong>{" "}
            application.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.onClose()}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={this.submit}
            disabled={this.state.updating}
          >
            {this.state.updating ? "Updating..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const deactivateApplicationStatusMessage = graphql(
  gql`
    mutation deactivateApplicationStatusMessage($id: ID!) {
      deactivate_application_status_message(id: $id)
    }
  `,
  { name: "deactivateApplicationStatusMessage" }
);

export default withRouter(
  compose<any>(deactivateApplicationStatusMessage)(
    ApplicationStatusMessageDeactivationConfirmationModal
  )
);
